import { useEffect } from 'react';

import { useFlag } from '@/features/unleash';

import type { ProfileState } from '@/hooks/useUser';
import { useUserAgent } from '@/context/UserAgent';

import { useUserpilot } from '../hooks/useUserpilot';

/**
 * This component updates some of the user's attributes to Userpilot
 * so Userpilot can use it for triggering conditions
 */

type Props = {
  user: ProfileState;
};

export const UserpilotIdentifyUser = ({ user }: Props) => {
  const userpilot = useUserpilot();
  const { isMobile } = useUserAgent();
  const flag = useFlag({ name: 'mono-userpilot-experience' });

  const { name: experience } = flag.variant;

  const isInTestVariant =
    flag.flagsReady && flag.enabled && experience && experience !== 'control';

  useEffect(() => {
    if (!isInTestVariant || typeof userpilot === 'undefined') {
      return;
    }

    userpilot.identify(user.id, {
      experience,
      isMobile: String(isMobile),
      created_at: new Date(user.registrationDate).toISOString(),
    });
  }, [
    experience,
    isInTestVariant,
    isMobile,
    user.id,
    user.registrationDate,
    userpilot,
  ]);

  return null;
};
